<footer class="flex flex-col pt-16">
  <img
    class="mx-auto"
    width="218"
    height="64"
    [ngSrc]="baseUrl + '/assets/imgs/logo_footer.svg'"
    alt="Mobo"
  />
  <div class="bg-primary-500 text-white py-6 -mt-px">
    <div class="flex flex-col items-center">
      <h3 class="text-3xl font-semibold mb-6 text-center font-display">
        COMER BEM, PAGANDO MENOS
      </h3>
      <div class="flex gap-6 lg:mb-36">
        <a
          href="https://www.facebook.com/mobocupons/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            width="48"
            height="48"
            class="w-auto"
            [ngSrc]="baseUrl + '/assets/imgs/socials/facebook.svg'"
            alt="Facebook"
          />
        </a>
        <a
          href="https://www.instagram.com/mobo_cupons/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            width="48"
            height="48"
            class="w-auto"
            [ngSrc]="baseUrl + '/assets/imgs/socials/instagram.svg'"
            alt="Instagram"
          />
        </a>
        <a
          href="https://www.tiktok.com/@mobocupons"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            width="48"
            height="48"
            class="w-auto"
            [ngSrc]="baseUrl + '/assets/imgs/socials/tiktok.svg'"
            alt="TikTok"
          />
        </a>
      </div>
      <div class="p-6 border-t border-primary-300 w-full">
        <div
          class="max-w-6xl mx-auto flex flex-col lg:flex-row justify-between items-center text-center px-2 sm:px-6 lg:px-8 2xl:px-16"
        >
          <span class="text-white text-lg"
          [title]="version"
            >©{{currentYear}}. Mobo Cupons. Todos os direitos reservados</span
          >

          <a routerLink="termos" class="text-white text-lg"
            >Termos e Políticas de Privacidade</a
          >
          <a routerLink="exclusao-de-conta" class="text-white text-lg"
            >Controle de seus dados</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
